import React from "react";

const Bidirectional = ({ color }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M9.70455 0.5H14.8182C15.1678 0.5 15.456 0.763209 15.4954 1.1023L15.5 1.18182V6.29545C15.5 6.67201 15.1947 6.97727 14.8182 6.97727C14.4685 6.97727 14.1803 6.71406 14.141 6.37497L14.1364 6.29545V2.82773L2.82773 14.1364H6.29545C6.64512 14.1364 6.9333 14.3996 6.97269 14.7387L6.97727 14.8182C6.97727 15.1678 6.71406 15.456 6.37497 15.4954L6.29545 15.5H1.18182C0.832157 15.5 0.543972 15.2368 0.504587 14.8977L0.5 14.8182V9.70455C0.5 9.32799 0.80526 9.02273 1.18182 9.02273C1.53148 9.02273 1.81966 9.28594 1.85905 9.62503L1.86364 9.70455V13.1716L13.1716 1.86364H9.70455C9.35489 1.86364 9.0667 1.60043 9.02732 1.26133L9.02273 1.18182C9.02273 0.832157 9.28594 0.543972 9.62503 0.504587L9.70455 0.5H14.8182H9.70455Z"
        fill={color}
      />
    </svg>
  );
};

export default Bidirectional;
